import Cookie from 'cookie-universal'
import { v4 as uuidV4 } from 'uuid'
import { GetServerSidePropsContext } from 'next'

const HELP_CENTER_ANON_UUID_COOKIE_KEY = 'mc_help_center_anon_uuid'

// This cookie is used for retaining chat history for logged-out users for a certain period of time.
// This way if they refresh the page their conversation is not lost.
// If they log in, the canonical user ID will be used instead.
// And the user won't see the chat history of when they were logged out.

// The refresh of the cookie is called server side because cookies can only be modified there
export const refreshHelpCenterAnonUuidCookie = (
  ctx: GetServerSidePropsContext,
) => {
  const cookies = Cookie(ctx.req, ctx.res)

  const existingUuid = cookies.get(HELP_CENTER_ANON_UUID_COOKIE_KEY)

  if (!existingUuid) {
    const uuid = `help-center-anon-uuid-${uuidV4()}`

    cookies.set(HELP_CENTER_ANON_UUID_COOKIE_KEY, uuid, {
      maxAge: 60 * 60 * 4, // 4 hours
    })
  }
}

// The get function is called client side to centralize the logic of getting the cookie
// Since it is needed in the layout of the help center that wraps multiple pages.
export const getHelpCenterAnonUuidCookie = () => {
  const cookies = Cookie()

  return cookies.get(HELP_CENTER_ANON_UUID_COOKIE_KEY)
}
